import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from "ngx-bootstrap";
import { NotificationsService } from "angular2-notifications";
import { Subscription } from "rxjs/Rx";
import { ActivatedRoute } from "@angular/router";

import { AdminService } from 'app/admin/admin.service';
import { User } from "app/shared/shared.module";

@Component({
    selector: 'app-admin-area-users',
    templateUrl: './admin-area-users.component.html',
    styleUrls: ['./admin-area-users.component.css']
})
export class AdminAreaUsersComponent implements OnInit {

    @ViewChild('AddUserModal') public AddUserModal: ModalDirective;

    NewUser: User = new User();
    Users = [];
    constructor(private route: ActivatedRoute, private adminService: AdminService, private _notification: NotificationsService) { }
    subRoute: Subscription;
    Type: string;
    LoadingUsers : boolean = true;
    NoUsers : boolean = false;
    clientUserView: boolean = false;

    ngOnInit() {
        this.subRoute = this.route.data.subscribe(
            d => {
                this.LoadingUsers = true;
                this.NoUsers = false;
                this.Type = d.Type;
                this.GetUsers(this.Type);
            }
        );
    }

    GetUsers(type) {
        this.LoadingUsers = true;
        this.NoUsers = false;
        this.clientUserView = type == "client";
        this.adminService.GetUsers().subscribe((res) => {
            console.log(res);
            this.Users = [];
            res.forEach((item) => {
                if (item.IsAdmin && !this.clientUserView )
                    this.Users.push(item);
                if (!item.IsAdmin && this.clientUserView )
                    this.Users.push(item);
            });
            this.LoadingUsers = false;
            this.NoUsers = this.Users.length == 0;
        });
    }

    OpenAddUserModal() {
        this.NewUser = new User();
        this.AddUserModal.show();
    };

    AddNewUser() {
        //this.NewUser.Username = this.NewUser.Name.split(" ").join(".").toLowerCase();
        console.log(this.NewUser);
        this.adminService.AddUser(this.NewUser).subscribe((res) => {
            this._notification.success("User Created", "User created successfully with the password '" + res.Password + "'")
            this.GetUsers(this.Type);
            this.CloseAddUserModal();
        });
    };

    CloseAddUserModal() {
        this.AddUserModal.hide();
    };
}



// WEBPACK FOOTER //
// ./src/app/admin/users/admin-area-users.component.ts